<app-attendee-layout
  [backLinkAriaLabel]="
    'attendee.activity_detail.back_link.aria_label' | translate
  "
  [backLink]="backLink"
>
  <app-activity
    [activity]="activity"
    [timeslots]="timeslots"
    [organization]="organization"
    [organizationReviewsStats]="organizationReviewsStats"
    [isPreview]="isPreview"
  >
    <app-attendee-activity-offers
      [activity]="activity"
      [timeslots]="timeslots"
      [hasSeeMoreUrl]="true"
    ></app-attendee-activity-offers>
    <app-loyalty-points-card
      class="loyalty-points-card"
      *appIsEnabled="toggleNameEnum.ActivityLoyaltyPoints"
      [link]="decatClubUrl"
      [ecological]="activity?.ecological"
    ></app-loyalty-points-card>
  </app-activity>
</app-attendee-layout>
